import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type ContentfulClientService from 'teacher-ui-client/services/contentful-client'

export default class CaseStudiesRoute extends Route {
  @service contentfulClient!: ContentfulClientService

  async model() {
    const { subscriptionType } = this.modelFor('subscription-type') as ModelForSubscriptionTypeRoute
    const caseStudies = await this.contentfulClient.getCaseStudies({ subscriptionType })

    return {
      caseStudies,
      subscriptionType,
    }
  }
}
